export default "__VITE_ASSET__Dff5Mdvt__"